import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { timestampToDateExcel } from '../../common/handleTimestamp';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import ExportExcel from './ExportExcel';

const ExportExcelButton = ({ table, name, sheet }) => {
  const { t } = useTranslation();
  const [sheetFile, setSheetFile] = useState();
  const [nameFile, setNameFile] = useState();

  const handleDownload = () => {
    document.querySelector('#table-xls-button').click();
  };

  useEffect(() => {
    if (table) {
      table.setAttribute('id', 'table-to-xls');
    }
    if (name && sheet) {
      setSheetFile(sheet);
      setNameFile(name + timestampToDateExcel(Date.now()));
    }
  }, [name, sheet, table]);

  return (
    <>
      <ExportExcel
        id="table-xls-button"
        className="d-none"
        table="table-to-xls"
        filename={nameFile}
        sheet={sheetFile}
        buttonText="Download as XLS"
      />
      <Button
        style={{ float: 'left' }}
        onClick={() => {
          handleDownload();
          toast.success('Exported excel successfully.');
        }}
      >
        + {t('export-report')}
      </Button>
    </>
  );
};

export default ExportExcelButton;
